<template>
  <div class="authPage flex">
    <div class="column">
      <div class="authPage-content">
        <div class="text-center authIcon" v-if="isRegister">
          <img
            src="/img/magic-clipboard.png"
            srcset="/img/magic-clipboard@2x.png 2x"
            alt="Clipboard"
          />
        </div>
        <div class="pagePretitle text-blue text-bold">
          <span v-if="isRegister">Your quote is ready</span>
          <span v-if="isLogin">Log in to your truesecurity</span>
        </div>
        <div class="pageTitle text-center">
          <span v-if="isRegister">Alright let’s get your quote and save&nbsp;you&nbsp;money</span>
          <span v-if="isLogin">Welcome back, Log in to your truesecurity account.</span>
        </div>
        <!-- <div>
          <a class="auth-socialButton" href="/login/google" @click="handleSocialClick">
            <img src="/img/google-icon.svg" alt="Google Icon" />
            <span>{{ type === 'Register' ? 'Continue' : 'Login' }} with Google</span>
          </a>
        </div>
        <div>
          <a class="auth-socialButton" href="/login/facebook" @click="handleSocialClick">
            <img src="/img/facebook-icon.svg" alt="Facebook Icon" />
            <span>{{ type === 'Register' ? 'Continue' : 'Login' }} with Facebook</span>
          </a>
        </div>
        <div class="orSep">
          <span>or</span>
        </div> -->
        <form ref="form" :action="authAction" method="POST">
          <input type="hidden" name="_token" :value="csrf" />
          <input type="hidden" name="type" :value="type" />
          <input type="hidden" name="mixpanelId" :value="mixpanelId" />
          <input type="hidden" name="intercomId" :value="intercomId" />
          <input type="hidden" name="leadUuid" :value="leadUuid" />
          <div class="form-group" v-if="type === 'Register'">
            <label for="name">Name</label>
            <input type="text" name="name" placeholder="First and Last Name" v-model="lead.name" />
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="text"
              name="email"
              placeholder="Email Address"
              v-model="lead.email"
              required
            />
          </div>
          <!-- <div class="form-group">
            <label for="password">Password</label>
            <input
              type="password"
              name="password"
              placeholder="Password"
              v-model="password"
              required
            />
          </div>-->

          <div class="errorMessages" v-show="errors.length">
            <div v-for="(message, index) in errors" :key="index">{{ message }}</div>
          </div>

          <textarea style="display: none;" name="assessment" cols="30" rows="10" :value="leadJson"></textarea>
          <textarea style="display: none;" name="system" cols="30" rows="10" :value="systemJson"></textarea>

          <div class="text-center auth-terms" v-if="isRegister">
            By signing up, I agree to truesecurity’s
            <a
              href="/terms-and-conditions"
            >terms and conditions</a> and
            <a href="/privacy-policy">privacy policy</a>.
          </div>

          <button
            class="button full"
            @click="submit"
            type="button"
            :disabled="!readyToContinue"
          >Continue</button>

          <!-- <template v-if="isRegister">
            <div class="startOverSection">
              Have an account?
              <a href="/assessment/login">Log In</a>
            </div>
          </template> -->
        </form>
      </div>
    </div>
    <div class="column">
      <div class="authBackground">
        <img src="/img/magic-clipboard.png" srcset="/img/magic-clipboard@2x.png 2x" alt="Clipboard" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.errorMessages {
  margin-bottom: 1em;
}
</style>


<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    type: "", // register or login
    csrf: document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content"),
    mixpanelId: "",
    intercomId: "",
    leadUuid: "",
    password: "",
    authAction: "",
    errors: []
  }),
  computed: {
    ...mapState(["lead", "system"]),
    leadJson() {
      return JSON.stringify(this.lead);
    },
    systemJson() {
      return JSON.stringify(this.system);
    },

    isRegister() {
      return this.type === "Register";
    },
    isLogin() {
      return this.type === "Login";
    },
    readyToContinue() {
      return this.lead.email;
    }
  },
  methods: {
    ...mapActions(["save"]),
    handleSocialClick(e) {
      e.preventDefault();
      let el = e.target;
      const tagName = e.target.tagName;
      if (tagName !== "A") {
        el = el.parentElement;
      }
      const href = el.getAttribute("href");
      this.authAction = href;
      this.submit();
    },
    submit() {
      let that = this;
      this.mixpanelId = mixpanel.get_distinct_id();
      this.intercomId = Intercom("getVisitorId");
      Vue.nextTick(() => {
        that.$refs.form.submit();
      });
    }
  },

  mounted() {
    console.log(this.leadUuid)
    if (!this.leadUuid) {
      window.location.reload();
    }
  },

  beforeMount() {
    this.leadUuid = window.trueUUID;
    if (this.$store.state.lead.protectionLevel) {
      this.save();
    }
    this.type = this.$route.path.includes("register") ? "Register" : "Login";
    this.authAction = this.isRegister ? "/register" : "/login";
    const mixpanelLoadEvent = this.isRegister
      ? "signUp_Viewed"
      : "Login_viewed";
    mixpanel.track(mixpanelLoadEvent);
    if (window.appErrors) {
      this.errors = appErrors;
    }
  }
};
</script>
